import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import Button from "@/components/common/Button";
import { RightOutlined } from "@/config/antd";

const BankCard = ({ bankLogo, bankName, amount }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-xl p-4 mb-3 cursor-pointer hover:shadow-md transition-shadow">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full overflow-hidden">
          <img
            src={bankLogo}
            alt={bankName}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h3 className="font-semibold text-darkGrey">{bankName}</h3>
          <p className="text-darkGrey">₦{amount}</p>
        </div>
      </div>
      <RightOutlined className="text-gray-400" />
    </div>
  </div>
);

const BankAccountsDialog = ({
  isVisible,
  onClose,
  accounts,
  onSelectAccount,
  onAddNewClick,
}) => {
  // Transform accounts data to match your UI structure
  const bankAccounts = accounts.map((account) => ({
    bankLogo: "/path-to-bank-logo.png",
    bankName: `${account.bankName} Account`,
    amount: account.amountToDeposit.toLocaleString(),
    originalAccount: account, // Keep reference to original account data
  }));

  const handleAccountSelect = (account) => {
    onSelectAccount(account.originalAccount);
  };

  const handleOpenAddBankAccountDialog = () => {
    onClose(); // Close the Bank Account modal
    if (onAddNewClick) {
      onAddNewClick(); // Call the parent's function to open Add Account Dialog
    }
  };

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        centered
        width={600}
        closeIcon={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden",
          },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}>
        <div className="flex flex-col bg-white">
          {/* Header */}
          <div className="px-6 pt-5 pb-4 text-center">
            <h3 className="heading-regular font-bold text-primary mb-2">
              My Accounts
            </h3>
            <p className="text-lighterGrey text-regular">
              Below are your list of existing accounts
            </p>
          </div>

          {/* Content Area - Bank Cards */}
          <div className="px-6 pb-6">
            {bankAccounts.map((account, index) => (
              <div onClick={() => handleAccountSelect(account)} key={index}>
                <BankCard
                  bankLogo={account.bankLogo}
                  bankName={account.bankName}
                  amount={account.amount}
                />
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="w-full bg-secondary p-4 flex gap-3">
            <Button
              text="CLOSE"
              color="secondary"
              className="flex-1 border border-primary"
              customBgColor="white"
              customTextColor="primary"
              onClick={onClose}
            />
            <Button
              text="ADD NEW"
              color="primary"
              customBgColor="primary"
              customTextColor="white"
              className="flex-1"
              onClick={handleOpenAddBankAccountDialog}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

BankCard.propTypes = {
  bankLogo: PropTypes.string,
  bankName: PropTypes.string,
  amount: PropTypes.string,
};

BankAccountsDialog.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  accounts: PropTypes.array,
  onSelectAccount: PropTypes.func,
  onAddNewClick: PropTypes.func,
};

export default BankAccountsDialog;
